import Card from 'components/Card'
import Button from 'components/common/buttons/Button'
import { DataForm, Input } from 'components/formik_inputs'
import API_HOST from 'consts'
import useFetch from 'hooks/useFetch'
import React from 'react'
import { useHistory, useParams } from 'react-router'
import {
    createPreceptor,
    deletePreceptor,
    editPreceptor,
} from '../../services/academic'
import { toast } from 'react-toastify'
import ButtonWithConfirmation from 'components/common/buttons/ButtonWithConfirmation'
import Skeleton from 'react-loading-skeleton'
const PreceptorForm = ( { props } ) => {
    const { id } = useParams()
    const history = useHistory()
    const [preceptor, loading] = useFetch(
        `${API_HOST}/academico/preceptores/${id}`,
        null,
        null,
        Boolean( id )
    )

    const handleSubmit = async ( values ) => {
        if ( id ) {
            await editPreceptor( id, values )
            toast.success( 'Preceptor editado com sucesso' )
            history.push( '/preceptores' )
        } else {
            await createPreceptor( values )
            toast.success( 'Preceptor cadastrado com sucesso' )
            history.push( '/preceptores' )
        }
    }

    const handleDelete = async () => {
        deletePreceptor( id )
        history.push( '/preceptores' )
        toast.success( 'Preceptor excluído com sucesso' )
    }

    if ( loading ) {
        return <Skeleton width={'100%'} height={'200px'} />
    }

    return (
        <Card title={( id ? 'Editar' : 'Cadastrar' ) + ' Preceptor'}>
            <DataForm
                autoSetErrors
                initialValues={preceptor || {}}
                onSubmit={( e ) => handleSubmit( e )}
            >
                {( formik ) => (
                    <>
                        <Input label="Nome" placeholder="Nome" name="nome" />
                        <Input label="RQE" placeholder="RQE" name="rqe" />
                        <div className="w-100 d-flex flex-row justify-space-between ">
                            <Button
                                type="button"
                                className="mt-2"
                                onClick={() => history.push( '/preceptores' )}
                            >
                                Voltar
                            </Button>
                            <div>
                                {id && preceptor && (
                                    <ButtonWithConfirmation
                                        confirmationText="Tem certeza que deseja apagar este preceptor?"
                                        onClick={() => handleDelete()}
                                        className="mt-2"
                                        action="danger"
                                    >
                                        Deletar
                                    </ButtonWithConfirmation>
                                )}
                                <Button type="submit" className="mt-2">
                                    Salvar
                                </Button>
                            </div>
                        </div>
                    </>
                )}
            </DataForm>
        </Card>
    )
}

export default PreceptorForm
